export class QuoteRevision {

	public QuoteId: number;
	public RevisionNumber: number;
	public RevisionComments: string;
	public DateCreated: string;
	public CreateUser: string;

	constructor() {
		this.QuoteId = null;
		this.RevisionNumber = null;
		this.RevisionComments = null;
		this.DateCreated = null;
		this.CreateUser = null;
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/quote-revision.ts